import { useAuthentication } from '@hooks/interview/useAthentication';
import { useGetPath } from '@hooks/interview/useGetPath';
import { useInterviewAPI } from '@hooks/interview/useInterviewAPI';
import { useInterviewSession } from '@hooks/interview/useInterviewSession';
import { useMeetingSession } from '@hooks/meeting/useMeetingSession';
import { useBrowser } from '@hooks/utils/useBrowser';
import { useException } from '@hooks/utils/useException';
import { MeetingMode } from '@interfaces/chime.enum';
import { useMeetingManager } from '@providers/MeetingProvider';
import { externalApiUrl } from '@stores/atoms/url';
import { useSetAtom } from 'jotai';
import { useEffect, type FC } from 'react';
import { useNavigate } from 'react-router';
import { Container } from './style';

const InterviewerHomePage: FC = () => {
  const setExternalApiUrl = useSetAtom(externalApiUrl);
  const { withLogger } = useException();
  const navigate = useNavigate();
  const meetingManager = useMeetingManager();
  const { initialize } = useMeetingSession(meetingManager);
  const { browserHelper } = useBrowser();
  const { rootPath } = useGetPath();
  const { getInterviewInfo, saveInterviewInfo } = useInterviewSession();
  const { fetchJoinMangerInterview } = useInterviewAPI();
  const { authenticateUser } = useAuthentication();

  const handleError = (error?: unknown) => {
    withLogger(error);
    navigate('/error', { replace: true });
  };

  const initSession = async () => {
    if (!browserHelper.checkChromeBrowser())
      return navigate(rootPath.CHECK_BROWSER, {
        replace: true,
      });

    try {
      saveInterviewInfo();

      const { name, certificationCode, valuerSn, apiUrl, intervieweeName } =
        getInterviewInfo();

      // console.log('============================');
      // console.log('name:', name);
      // console.log('certificationCode:', certificationCode);
      // console.log('valuerSn:', valuerSn);
      // console.log('apiUrl:', apiUrl);
      // console.log('intervieweeName:', intervieweeName);
      // console.log('============================');

      if (!name || !certificationCode || !intervieweeName)
        return handleError('이름과 응시코드를 확인하세요.');

      const externalApiAddr = `https://${apiUrl}`;
      setExternalApiUrl(externalApiAddr);

      const isAuthenticated = await authenticateUser({
        name: intervieweeName, // 면접관 케이스라 응시자 이름을 써준다
        certificationCode,
        apiUrl: externalApiAddr,
      });

      if (!isAuthenticated) return handleError('이름과 응시코드를 확인하세요.');

      if (!valuerSn) return handleError('이름과 응시코드를 확인하세요.');

      const interviewSession = await fetchJoinMangerInterview({
        name,
        certificationCode,
        valuerSn,
      });

      if (!interviewSession.status)
        return handleError('존재하지 않는 방 입니다.');

      const isInitReady = await initialize({
        JoinInfo: interviewSession.data.JoinInfo,
        meetingMode: MeetingMode.Attendee,
      });

      if (!isInitReady)
        return handleError('인터뷰 생성실패, 고객센터에 문의하세요.');

      navigate(rootPath.SETTING, { replace: true });
    } catch (error) {
      return handleError(error);
    }
  };

  useEffect(() => {
    (async () => await initSession())();
  }, []);

  return <Container />;
};

export default InterviewerHomePage;
